import React from 'react'

export default function Loader({ fullPage, absolute, size, position }) {

  return (
    <div className={`loader-wrapper ${ position } ${ absolute ? 'absolute' : '' } ${ fullPage ? 'full-page' : '' }`}>
      <div className={`loader ${ size }`}></div>
    </div>
  )
}
